import { render, staticRenderFns } from "./SQuesEight.vue?vue&type=template&id=134e47f4&"
import script from "./SQuesEight.vue?vue&type=script&lang=js&"
export * from "./SQuesEight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports